import reduceReducer from '@helpers/reduceReducers';

import { namespace } from '../models';

import inviteReducer from './invites';
import organizationReducer from './organization';
import upgradeReducer from './upgrade';

const reducers = reduceReducer(
  inviteReducer,
  upgradeReducer,
  organizationReducer
);

export const userOnboardingReducers = {
  [namespace]: reducers,
};
